// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"3ea542c7","283":"bab7aa1c","329":"f64380c5","411":"d91dea51","453":"e9e7ec89"}[chunkId] + ".chunk.js";
};